import React from "react";
import { IListObj } from "../../types/genericTypes";

export const holdSecNavOptions: Array<IListObj> = [
	{ value: "equity", display: "Equity", href: "/holding/equity/usable" },
	{ value: "mf", display: "Mutual Funds", href: "/holding/mf/usable" }
];

export enum EHoldScreenState {
	LOADING,
	NO_DATA,
	DATA
}

export const holdNote = (
	<p>
		Mutual Fund holdings lying in collateral and hold will not be shown here, this happens if you take up a new Position in FNO using Mutual
		Funds as collateral.
		<br />
		<br />
		Redemption orders placed n physical mode may get rejected in case prior redemption orders are not yet settled.
	</p>
);
